import { gql } from '@apollo/client';

const loggedInUserQuery = gql`
  query LoggedInUser {
    loggedInUser {
      user {
        person {
          email
          fullName
          photoUrl
        }
      }
      basket {
        items {
          total
        }
      }
    }
  }
`;

export default loggedInUserQuery;
